import $ from 'jquery';
$(function () {
  var $backToTop = $('.back-to-top');
  var $body = $('body');
  $backToTop.on('click touch', goToTop);

  ////

  function goToTop() {
    $("html, body").animate({
      scrollTop: 0
    }, "slow");
  }
});